import React, { useRef, useState, useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import Spinner2 from "../../common/Spinner/Spinner2";
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import ModalComponent from '../../common/Modal/ModalComponent.js';
import { getDepot,fetchSavedView,InsertDepots ,insertHookOff,customHookoff, getProblemCodes, baseUrl, ChangePlanDepartment, getDepartments, ChangePlanSubdepartment, getSubdepartments, getShipmentActions, getMovement, postSetFreeRoutes } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent.jsx';
import ActionButton from '../../../../shared/common-utilities/common/ActionButton';
import { PlanFunctionsForFlag } from '../../../../shared/common-utilities/enums/PlanFunctionsEnum.jsx';
import i18_en from '../../../../jsonStore/i18_en.json';

let entity = "transportAddress";
let entityNameFor = "transportAddress";
let odataApiName = "transportAddresses";
let odataApiNameFor = "transportAddresses";
let isChild = false;
let service = getSetDataService();
let apiService = commonApiService();
let initialSort = service.initialSort["default"];
let dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh'];
let gridSelectedValues = {};

const Depot = (props) => {
  //#region Reference
  const depotGridRef = useRef(null);
  //#endregion Reference

  //#region Hook Selctor

  //#endregion Hook Selctor

  const depotDataItemKey = "id";

  //#region States - Get set variables
  const [tempdepotData, setTempDepotData] = useState([]);
  const [depotGridColumnList, setDepotGridColumnList] = React.useState(null);
  const [tempDepotGridColumnList, setTempDepotGridColumnList] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
  const [loadedGridData, setLoadedGridData] = useState(tempdepotData);
  const [isDepot, setIsDepot] = useState(true);
  const [myGridData, setMyGridData] = useState([]);
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  const [nextDataUrl, setNextDataUrl] = useState(null);
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [loadSelectionValue, setLoadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState();
  const [changeToChildDepot, setChangeToChildDepot] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);
  const [canExecute, setCanExecute] = useState([]);
  const userID = localStorage.getItem('userID');

  const depotFilterComponents = [{ type: 'DropDownList', key: 'depot', value: "true", label: 'Depot', data: ["true", "false"], visible: false }];
  //#endregion States

  //#region Hooks  

  useEffect(() => {
    // setIsLoading(true);

    setIsApiLoaded(true);
    const parameters = JSON.parse(props.params?.result).parameters;
    entity = parameters[0].name;
    entityNameFor = entity + (props?.params?.for ? props?.params?.for : '');
    odataApiName = parameters[0].entityName;
    odataApiNameFor = odataApiName + (props?.params?.for ? props?.params?.for : '');
    if (props?.params?.for === PlanFunctionsForFlag.SetFreeRoutes) {
      isChild = true;
      dataRelatedAction = dataRelatedAction.filter(e => e !== 'Filter');
    } else {
      isChild = false;
    }
    setGridColumns(entity);
    initialSort = odataApiName === 'shipmentActions' ? service.initialSort["shipmentAction"] : service.initialSort["default"];
    let tempFilterData = [];
    if (parameters[0]?.restrictions !== null && parameters[0]?.restrictions !== undefined) {
      const restrictions = parameters[0]?.restrictions || [];
      if (parameters[0]?.restrictions?.Group?.values && parameters[0]?.restrictions.Group.values.length > 0) {
        const group = parameters[0]?.restrictions.Group;
        for (const value of group.values || []) {
          if (group.booleanOperator) {
            if (value.name.toLowerCase() === 'id') {
              tempFilterData.push({ field: value.name, value: value.value.replace(/[{}]/g, ''), isLast: false, type: 'Edm.Guid', condition: value.condition, operator: group.booleanOperator });
            }
          }
        }
      } else {
        for (const restriction of restrictions) {
          if (typeof restriction.value === 'boolean') {
            tempFilterData.push({ field: restriction.name, value: '=' + restriction.value, isLast: false, type: 'Edm.Boolean' });
          } else if (typeof restriction.value === 'string') {
            tempFilterData.push({ field: restriction.name, value: '=' + restriction.value, isLast: false, type: 'Edm.String' });
          } else if (typeof restriction.value === 'number') {
            tempFilterData.push({ field: restriction.name, value: '=' + restriction.value, isLast: false, type: 'Edm.Int32' });
          }
        }
      }
    }
    setInitialFilter(tempFilterData);
  }, []);

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityNameFor + 'ColumnList');
    if (!_.isNil(columnList)) {
      setDepotGridColumnList(JSON.parse(columnList));
      getColList(JSON.parse(columnList));
      return true;
    }

    apiService.getODataMetadata().then(odataRes => {
      service.entityDefinitions(odataRes, entityName).then((tempFieldList) => {
        localStorage.setItem(entityNameFor + 'ColumnList', JSON.stringify(tempFieldList));
        setDepotGridColumnList(tempFieldList);
        getColList(tempFieldList);
      })
    })
    .catch(error => {
      console.error('API error:', error);
    })
  }

  const getDefaultColList = (dcolsStringDepot, gridcolumns) => {
    const dColsDepot = JSON.parse(localStorage.getItem("defaultColumnSetting"));
    if (!_.isNil(dcolsStringDepot) && dcolsStringDepot != "undefined" ) {
      const defaultColumnListDepot = gridcolumns?.filter(item => {
        return dColsDepot[entity]?.split("~").includes(item.field);
      });
      if (defaultColumnListDepot.length == 0) {
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempDepotGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnListDepot, function (item) { return dColsDepot[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(sortedArr));
        setTempDepotGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setDepotGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempDepotGridColumnList(gridcolumns);
    }
  }

  const getColList = (gridcolumns) => {
    const url = `${fetchSavedView}?$filter=(title eq '${odataApiNameFor}' and userID eq '${userID}')`;
    const dcolsString = localStorage.getItem("defaultColumnSetting");
    apiService.get(url).then(savedViewRes => {
      if (savedViewRes?.value?.length > 0) {
        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], savedViewRes.value[0]["@odata.etag"]).then(readRes => {
          if (readRes !== undefined && readRes !== null) {
            setInitialSaveViewData(savedViewRes.value);
            setInitialFetchReadLinkData(readRes);
            const defaultViewExist = readRes[odataApiNameFor]?.savedViews?.filter(item => item.defaultView);
            if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
              setCanExecute(defaultViewExist);
              const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
              if (favFilterExist?.length > 0) {
                setTempDepotGridColumnList(defaultViewExist[0].columns);
              }
            } else if (readRes[odataApiNameFor]?.columns?.length !== 0) {
              localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(readRes[odataApiNameFor]?.columns));
              setTempDepotGridColumnList(readRes[odataApiNameFor]?.columns);
            } else {
              getDefaultColList(dcolsString, gridcolumns);
            }
          }
        })
      } else {
        getDefaultColList(dcolsString, gridcolumns);
      }

      setIsLoading(false);
    });
  }

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      updateSendApi(loadSelectionValue);
    } else {
      setIsApiCallRequired(true);
    }
  }, [paramsData]);

  useEffect((e) => {
    if (!_.isNil(tempDepotGridColumnList)) {
        setNextDataUrl(null);
        updateSendApi(loadSelectionValue);
    }
  }, [tempDepotGridColumnList]);

  // --- API's Call START ---

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setOpenConfirmationModal(true);
  }

  const closeConfirmationModal = (e, flag) => {
    setOpenConfirmationModal(false);
    setCommonPopupParameters({});
    if (e && flag && flag === PlanFunctionsForFlag.HookOff) {
      callInsertAPI(insertHookOff, e);
    } else if (e && flag && flag === PlanFunctionsForFlag.CustomHookOff) {
      callInsertAPI(customHookoff, e);
    } else if (e && flag && flag === PlanFunctionsForFlag.SetFreeRoutes) {
      callInsertAPI(postSetFreeRoutes, e);
    } else {
      props.onClose();
    }
  }

  const sendApi = (val, size) => {
    if (props.params.result && props.params.for === PlanFunctionsForFlag.Depot && (paramsData.filter === null || paramsData.filter === undefined)) { 
      let name = '';
      let condition = '';
      let value = '';
      const result = JSON.parse(props.params.result)
      if (result.parameters.length > 0) {
        if (result.parameters[0].restrictions.length > 0) {
          name = result.parameters[0].restrictions[0].name;
          condition = result.parameters[0].restrictions[0].condition;
          value = result.parameters[0].restrictions[0].value;
          if (_.isString(value)) {
            paramsData.filter = name + " " + condition + " '" + value + "'"
          } else {
            paramsData.filter = name + " " + condition + " " + value + ""
          }
        }
      }
    }
    let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if (canExecute?.length > 0) {
      return;
    }
    if (tempDepotGridColumnList !== null && tempDepotGridColumnList !== undefined && tempDepotGridColumnList.length > 0) {
      setIsLoading(true);
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempDepotGridColumnList?.map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (mandatroyEntity) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~")
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }
      
      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      let url = '';
      if (odataApiName === 'problemCodes') {
        url = getProblemCodes;
      } else if (odataApiName === 'departments') {
        url = getDepartments;
      } else if (odataApiName === 'subdepartments') {
        url = getSubdepartments;
      } else if (odataApiName === 'shipmentActions') {
        url = getShipmentActions;
      } else if (odataApiName === 'movements') {
        url = getMovement;
      } else {
        url = getDepot;
      }
      apiService.get(url, params, `${selectFields}`, oDataNextLink, size, null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemoveDepot = response.error.message.split("'")[1];
            setChangeToChildDepot({ type: "sort", value: sortToRemoveDepot });
          } else if (response?.error?.code == "Application_FilterErrorException") {
            const filterToRemoveDepot = response.error.message.split("'")[1];
            setChangeToChildDepot({ type: "filter", value: filterToRemoveDepot });
          }
        } else {
          if (response.value) {
            setTotalData(response["@odata.count"]);
            let tempData = [];
            if (val == 'Scroll' && tempdepotData !== null && tempdepotData !== undefined && tempdepotData.length > 0) {
              tempdepotData.forEach(tempDepot => {
                tempData.push(tempDepot);
              });
              response.value.map(temp => {
                  tempData.push(temp)
              })
            } else {
              tempData = response.value;
            }

            tempData = service.setColorCodeAndDate(tempData,depotGridColumnList);
            if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
              setNextDataUrl(response['@odata.nextLink']);
            }

            setTempDepotData(tempData);
            setMyGridData(tempData);
            setLoadedGridData(tempData);
            setIsApiLoaded(true);
          }
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
          if (props?.sendDataToParent) {
            props.sendDataToParent(odataApiName);
          }
        });
    } else {
      setIsLoading(false);
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      sendApi(null, size);
    }, 250);
  }, [sendApi]);

  // --- API's Call END ---

  const onLoadSelectionChange = (e) => {
    let value = e.value;
    setLoadSelectionValue(value);
    sendApi(null, value);
  }

  const closePopup = () => {
    props.onClose();
  }

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const onOkClick = () => {
    let transferdataId = Object.entries(gridSelectedValues).filter(([key, value]) => value === true).map(([key]) => key);
    if (transferdataId.length === 0) {
      let errorMsg = '';
      if (odataApiName === 'problemCodes') {
        errorMsg = i18_en.selectProblemCode;
      } else if (odataApiName === 'departments') {
        errorMsg = i18_en.selectPlanDepartment;
      } else if (odataApiName === 'subdepartments') {
        errorMsg = i18_en.selectPlanSubdepartment;
      } else if (odataApiName === 'shipmentActions') {
        errorMsg = i18_en.selectShipmentActions;
      } else if (odataApiName === 'movements') {
        errorMsg = i18_en.selectMovements;
      } else {
        errorMsg = i18_en.selectTransportAddress;
      }
      setErrorSnackbarMessage(errorMsg);
      setErrorSnackbarOpen(true);
      return;
    }
    let firstTransferdataIdString = transferdataId[0];
    if (props.params.for == PlanFunctionsForFlag.SetFreeRoutes) {
      const movementObject = [];
      transferdataId.forEach(item => {
        movementObject.push({
            "id": item
        });
      });
      const gridFlagVal = props.params?.for === PlanFunctionsForFlag.SetFreeRoutes ? 'routes' : 'movements';
      const obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify({ movements: movementObject }), gridFlagVal);
      callInsertAPI(postSetFreeRoutes, obj, PlanFunctionsForFlag.SetFreeRoutes);
    } else if (props.params.for == PlanFunctionsForFlag.OnHold) {
      const inputData = {
        problemCode: firstTransferdataIdString
      };
      const inputJson = JSON.stringify(inputData);
      const obj = {
        "input": inputJson
      }
      setIsLoading(true);
      apiService.postWithId(baseUrl,"movements",props.params.movementlines, 'Microsoft.NAV.toggleOnHold', obj).then(response => {
        if (response.error) {
          setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
        } else {
          props.onClose(response);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      })
    } else if (props.params.for === PlanFunctionsForFlag.ChangePlanDepartment || props.params.for === PlanFunctionsForFlag.ChangePlanSubdepartment) {
      let apiEndPointName = ChangePlanDepartment; 
      let inputData = {
        department: firstTransferdataIdString
      };
      if (props.params.for === PlanFunctionsForFlag.ChangePlanSubdepartment) {
        apiEndPointName = ChangePlanSubdepartment;
        inputData = {
          subdepartment: firstTransferdataIdString
        };
      }
      const obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify(inputData));
      callInsertAPI(apiEndPointName, obj);
    } else {
      let inputData = {
        transportAddress: firstTransferdataIdString
      };
      if (props.params.for == PlanFunctionsForFlag.CustomHookOff) {
        const customInputData = JSON.parse(props.params?.input);
        inputData = {
          transportAddress: firstTransferdataIdString,
          hookOffActionCode: customInputData.hookOffActionCode,
          hookOnActionCode: customInputData.hookOnActionCode
        };
      } else if (props.params.for == PlanFunctionsForFlag.InsertTerminals && odataApiName === 'shipmentActions') {
        const customInputData = JSON.parse(props.params?.input);
        inputData = {
          transportAddress: customInputData.transportAddress,
          shipmentAction: firstTransferdataIdString
        };
      }
      const obj = service.movementLinesAndOperationDeatilObject(props.params?.movementlines, JSON.stringify(inputData));
      if (props.params.for == PlanFunctionsForFlag.Depot) {
        callInsertAPI(InsertDepots, obj, PlanFunctionsForFlag.Depot);
      } else if (props.params.for == PlanFunctionsForFlag.InsertTerminals) {
        setOpenConfirmationModal(false);
        props.onClose(obj, PlanFunctionsForFlag.InsertTerminals);
      } else if (props.params.for == PlanFunctionsForFlag.CustomHookOff) {
        callInsertAPI(customHookoff, obj, PlanFunctionsForFlag.CustomHookOff, inputData);
      } else {
        callInsertAPI(insertHookOff, obj, PlanFunctionsForFlag.HookOff, inputData);
      }
    }
  }

  const callInsertAPI = (apiEndPointName, obj, forFlag, inputData = null) => {
    setIsLoading(true);
    apiService.post(apiEndPointName, obj).then(response => {
      if (response.error) {
        setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
      } else {
        const result = JSON.parse(response?.operationDetail[0]?.result);
        if (service.apiOKResultChecker(result)) {
          setOpenConfirmationModal(false);
          props.onClose(response);
        } else if (result.parameters[0].name === 'hookOffDateTime' && result.parameters[1].name === 'hookOnDateTime') {
          let options = [{
            transportAddress: inputData.transportAddress
          }];
          if (props.params.for === PlanFunctionsForFlag.CustomHookOff) {
            options = [{
              transportAddress: inputData.transportAddress,
              hookOffActionCode: inputData.hookOffActionCode,
              hookOnActionCode: inputData.hookOnActionCode,
            }];
          }
          const param = {
            movementlines: props.params.movementlines,
            title: 'Select Hook Off/On Time',
            for: forFlag,
            options: options,
            parameters: result.parameters
          };
          setOpenConfirmationModal(true);
          setCommonPopupParameters(param);
        }  else if (result.parameters && result?.parameters[0]?.type === 'Dialog.ConfirmSingleLine' && result?.parameters[0]?.name === 'deleteTripQuestion') {
          const param = {
            movementlines: props.params?.movementlines,
            title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
            parameters: result.parameters,
            for: forFlag,
            data: result.data
          };
          setOpenConfirmationModal(true);
          setCommonPopupParameters(param);
        } else {
          setOpenConfirmationModal(false);
          props.onClose();
        }
      }
    })
      .catch(error => {
        console.error('API error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  const childStateHandler = (value, flag) => {
    if (flag === 'showGridHeader') {
      setIsDepot(value);
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      setIsApiCallRequired(value.isApiCall);
      setTempDepotGridColumnList(value.columns);
      setCanExecute([]);
    } else if (flag === 'refresh') {
      sendApi(null, loadSelectionValue);
    } else if (flag === 'selectedValues') {
      gridSelectedValues = value;
    } else if (flag === 'columnsVisible') {
      setTempDepotGridColumnList(value);
    }
  }

  return (
    <>
      {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} id={odataApiName}>

        <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} />

        {isDepot && <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>{props.params.for}</Typography>
        </Box>}
        <Grid container sx={{ marginTop: 0 }} className='filterbar-bg'>
          <Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
            {isApiLoaded && <DataGridComponent
              {...props}
              gridRef={depotGridRef}
              gridFlagVal={odataApiName}
              gridFlagValFor={odataApiNameFor}
              gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px'}}
              loadedGridData={loadedGridData}
              gridNewData={myGridData}
              tempGridData={tempdepotData}
              gridColumnList={depotGridColumnList ? depotGridColumnList : []}
              gridTempColumnList={tempDepotGridColumnList ? tempDepotGridColumnList : []}
              gridSort={initialSort}
              isItemVisible={true}
              gridInitialFilter={initialFilter}
              isShowGridHeader={isDepot}
              griddDtaItemKey={depotDataItemKey}
              gridDraggable={props?.params?.for === PlanFunctionsForFlag.SetFreeRoutes}
              sendDataToParent={childStateHandler}
              gridDataAction={dataRelatedAction}
              gridPlanAction={[]}
              gridFilterComponents={depotFilterComponents}
              selectableMode={props?.params?.for === PlanFunctionsForFlag.SetFreeRoutes ? 'multiple' : 'single'}
              onLoadSelectionChange={onLoadSelectionChange}
              loadSelectionValue={loadSelectionValue}
              gridtotalData={totalData}
              initialSaveViewData={initialSaveViewData}
              initialFetchReadLinkData={initialFetchReadLinkData}
              changeToChild={changeToChildDepot}
              isChild={isChild}
            />}
          </Grid>
        </Grid>
        <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />
      </Grid>
      {
        props?.openModalDepot && (
          <ActionButton onOkClick={onOkClick} closePopup={closePopup} />
        )
      }
    </>
  )
};

export default Depot;